(function () {
    angular.module('pages.scrolledContent', [])
        .controller('scrolledContentController', scrolledContentController);

    /**
     * @ngdoc controller
     * @name pages.scrolledContentController
     * @description
     * Controller used for scrolled content doc type.
     */
    scrolledContentController.$inject = ['$scope', '$location', '$window'];
    function scrolledContentController($scope, $location, $window) {
        $scope.checkHash = function (anchor) {
            fromUpdate = false;
            if (anchor.target === $location.hash()) {
                anchor.$$scrollToTarget(true);
            }
        }
        var fromUpdate = false;
        $scope.updateHash = function (anchor) {
            fromUpdate = true;
            if (anchor) {
                $location.hash(anchor.target).replace();
            }
            else {
                if (window.history) {
                    history.replaceState('', document.title, $window.location.pathname);
                }
            }
        }

        var scrollLinks = angular.element('a[href*="' + $location.path() + '#"]').on('click.scrolledContent', function ($event) {
            var target = angular.element($event.currentTarget).attr('href').split('#')[1];
            angular.element('anchor[target="' + target + '"]').click();
        });
    }
})();